module.exports = __webpack_public_path__ + "img/010029.23c2958c.png";